export const PAGE_NAME_MAPPING: Record<string, string> = {
  dashboard: 'Dashboard',
  campaigns: 'Campaigns',
  createCampaign: 'Create campaign',
  editCampaign: 'Edit campaign',
  copyCampaign: 'Create campaign',
  returnAds: 'Return ads',
  createReturnAd: 'Create return ad',
  editReturnAd: 'Edit return ad',
  viewAdvertiser: 'View advertiser',
  advertiserReportEditor: 'Advertiser report',
  clients: 'Clients',
  creators: 'Creators',
  identity: 'Identity',
  contentLibrary: 'Content library',
  viewCreator: 'Creator details',
  segments: 'Segments',
  segmentCreate: 'Create segment',
  segmentEdit: 'Edit segment',
  marketingNotifications: 'Marketing notifications',
  marketingNotificationCreate: 'Create notification',
  marketingNotificationEdit: 'Edit notification',
}
